var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-size",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7528_152759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42871 2.71436H4.143C3.35402 2.71436 2.71443 3.35396 2.71443 4.14294V8.42865C2.71443 9.21763 3.35402 9.85722 4.143 9.85722H8.42871C9.21769 9.85722 9.85728 9.21763 9.85728 8.42865V4.14294C9.85728 3.35396 9.21769 2.71436 8.42871 2.71436Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8572 2.71436H15.5715C14.7825 2.71436 14.1429 3.35395 14.1429 4.14293V8.42864C14.1429 9.21762 14.7825 9.85721 15.5715 9.85721H19.8572C20.6462 9.85721 21.2858 9.21762 21.2858 8.42864V4.14293C21.2858 3.35395 20.6462 2.71436 19.8572 2.71436Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42864 14.1429H4.14293C3.35395 14.1429 2.71436 14.7825 2.71436 15.5715V19.8572C2.71436 20.6462 3.35395 21.2858 4.14293 21.2858H8.42864C9.21762 21.2858 9.85721 20.6462 9.85721 19.8572V15.5715C9.85721 14.7825 9.21762 14.1429 8.42864 14.1429Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8572 14.1429H15.5715C14.7825 14.1429 14.1429 14.7825 14.1429 15.5715V19.8572C14.1429 20.6462 14.7825 21.2858 15.5715 21.2858H19.8572C20.6462 21.2858 21.2858 20.6462 21.2858 19.8572V15.5715C21.2858 14.7825 20.6462 14.1429 19.8572 14.1429Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7528_152759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.d62e0ff7a9b5fecc49793a7dd246dd05.svg";
export { ForwardRef as ReactComponent };